import React, { useState } from 'react';
import InputButton from '../../../Shared/FormComponents/InputButton';
import InputText from '../../../Shared/FormComponents/InputText';
import { remindCustomerId } from '../../../../lib/api/user';
import { stripUsernameChars } from '../../../Shared/StringManipulation';
import Form from '../../../Shared/Form';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';

const CustomerReminderIdForm = () => {

    const [loading, setLoading] = useState();
    const [success, setSuccess] = useState();
    const [successMessage, setSuccessMessage] = useState();

    const requestCustomerIdReminder = ({ account, email }, { setStatus, setErrors }) => {
        console.log('running requestCustomerIdReminder function for account:', account, ' email:', email);
        setLoading(true);
        remindCustomerId(account.trim(), email.trim())
            .then(resp => {
                console.log('success', resp);
                setLoading(false);
                setSuccess(true);
                setSuccessMessage("We're on it! If those details are correct, you will shortly receive a customer ID reminder email");
            })
            .catch(err => {
                console.log('err', err)
                setLoading(false);
                setSuccess(true);
                setSuccessMessage("We're on it! If those details are correct, you will shortly receive a customer ID reminder email");
            })
    }

    return (
        <div className="w-full max-w-450px m-auto">
            <div className="bg-white w-full rounded-2xl">
                <div className="p-40px sm:p-60px">
                    <h3 className="uppercase text-18px sm:text-16px text-everflow-magenta font-bold text-center">Need a Customer ID Reminder?</h3>

                    {success ? (
                        <div className="mt-32px">
                            <p className="text-everflow-black text-center">{successMessage}</p>
                        </div>
                    ) : (
                        <div className="mt-32px">
                            <p className="text-everflow-black text-center">No worries! Simply submit your account number and email address to receive a Customer ID reminder</p>
                            <Form
                                initialValues={{ account: '', email: '' }}
                                validationSchema={customerIdReminderSchema}
                                onSubmit={requestCustomerIdReminder}
                                className="mt-32px grid grid-cols-1 gap-y-24px justify-items-center"
                            >
                                {({ values, handleChange, setFieldValue, errors, touched, handleBlur, handleSubmit }) => {
                                    return (
                                        <>
                                            <InputText
                                                label="Account number"
                                                placeholder="e.g. EFW000000-0"
                                                className="w-full rounded-28px"
                                                id="account"
                                                req
                                                value={values.account}
                                                error={errors.account}
                                                onChange={ev => stripUsernameChars(ev.target.value, val => setFieldValue('account', val))}
                                                onBlur={handleBlur}
                                            />

                                            <InputText
                                                label="Email address"
                                                placeholder="name@example.com"
                                                className="w-full rounded-28px"
                                                id="email"
                                                req
                                                value={values.email}
                                                error={touched.email ? errors.email : undefined}
                                                onChange={(e) => setFieldValue('email', e.target.value.trim())}
                                                onBlur={handleBlur}
                                                autoComplete="email"
                                                inputMode="email"
                                                name="email"
                                                type="email"
                                                spellCheck={false}
                                                aria-describedby="email-help"
                                            />

                                            <InputButton
                                                id="request-customer-id-reminder-button"
                                                loading={loading}
                                                className="w-full font-bold"
                                                label="Request Customer ID Reminder"
                                                onClick={handleSubmit}
                                            />
                                        </>
                                    )
                                }}

                            </Form></div>
                    )}

                </div>
                <div className="p-32px text-center border-t-2 border-gray-default-500">
                    <div>
                        <Link className="underline text-everflow-black" to="/">Return to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

const customerIdReminderSchema = Yup.object().shape({
    account: Yup.string().required('Please enter your account number'),
    email: Yup.string()
        .email('Please enter a valid email address')
        .required('Please enter your email address'),
})

export default CustomerReminderIdForm
